export const returnVehicle = {
    "401(K)":"Work Retirement Plan",
    "401(k) at work":"Work Retirement Plan",
    "IRA":"Individual Retirement Plan",
    "IRA and 401(k)":"Both",
    "No Retirement Account Yet":"No Retirement Account Yet",
    "Other Retirement Account":"Other Retirement Account"
}
